export default function TrustLockup() {
  return (
    <div className="trust-lockup">
      HIPAA-compliant <span className="sep" aria-hidden="true">·</span>{' '}
      Payments processed by Stripe{' '}
      <span className="sep" aria-hidden="true">·</span>{' '}
      <a
        href="mailto:support@brite.live"
        className="trust-link"
        data-no-tap="true"
      >
        support@brite.live
      </a>
    </div>
  )
}
